import React, {useEffect, useMemo, useState} from 'react';
import { ReactComponent as CirclePlus } from '../../svg/chevron-down.svg';
import { connect } from 'react-redux';
import ReactModal from 'react-modal';
import ExtraPackageDetails from '../ExtraPackages/ExtraPackageDetails';
import cn from 'classnames';
import { productCurrentProductIdSelector } from '../../redux/selectors/productSelector';
import { cartCartSelector, cartCurrencySelector, cartMainProduct } from '../../redux/selectors/cartSelector';
import getBillingUnitsCount from '../../resolvers/getBillingUnitsCount';
import getExtraPackageNote from '../../resolvers/getExtraPackageNote';
import getFormattedAmount from '../../resolvers/getFormattedAmount';
import isPeriodDifferentByProducts from '../../resolvers/isPeriodDifferentByProducts';
import getCostPerUnitNumber from '../../resolvers/getCostPerUnitNumber';
import { MINIMUM_ALLOWED_PRODUCT_PRICE } from '../../constants/constants';

function TableBody({ product_id, product, currency, includeExtra, cart, mainProduct }) {
    const [modalOpened, setModalOpened] = useState(false);
    const [tariffCost, setTariffCost] = useState('-');
    const [costPerSite, setCostPerSite] = useState('-');
    const [extraVisible, setExtraVisible] = useState(false);
    const [descriptionVisible, setDescriptionVisible] = useState(product_id === mainProduct?.product_id);
    const sign = <span dangerouslySetInnerHTML={{ __html: currency?.sign }}></span>;
    const [billingUnits, setBillingUnits] = useState(0);

    const sum = useMemo(() => {
        const extraSum = includeExtra
            ? Number(
                product?.tariff?.cost *
                currency?.rate *
                product?.period?.interval *
                product?.extra_package_rate
            ).toFixed(2)
            : Number(0).toFixed(2);
        if(!extraSum || isNaN(extraSum)) {
            return '-';
        } else {
            return(
                <>
                    {sign}
                    {extraSum ?? '-'}
                </>
             );
        }
    }, [mainProduct?.includeExtra, product?.tariff, product?.period, currency])

    useEffect(() => {
        if (isPeriodDifferentByProducts(mainProduct, product)) {
            setBillingUnits(null);
        } else {
            setBillingUnits(getBillingUnitsCount(product, cart));
        }
    }, [product?.product_id, product?.tariff, product?.period, cart?.domains]);

    useEffect(() => {
        if (isPeriodDifferentByProducts(mainProduct, product)) {
            setCostPerSite('-');
            setTariffCost('-');
            return;
        }
        const cost = getCostPerUnitNumber(
            product?.tariff?.cost * currency?.rate * product?.period?.interval
        );

        if (billingUnits) {
            setCostPerSite(
                <>
                    {sign}
                    {getCostPerUnitNumber(
                        (product?.tariff?.cost * currency?.rate) /
                        billingUnits
                    )}
                </>
            );
        } else {
            setCostPerSite('-');
        }
        if (cost > MINIMUM_ALLOWED_PRODUCT_PRICE) {
            setTariffCost(
                <>
                    {sign}
                    {cost}
                </>
            );
        } else {
            setTariffCost('-')
        }
    }, [product?.tariff, product?.period, currency, cart?.domains, billingUnits]);

    const handleExtraVisible = () => {
        setExtraVisible((prev) => !prev);
    };

    const handleDescriptionVisible = () => {
        setDescriptionVisible((prev) => !prev);
    };

    const handleIncludeExtra = () => {
        if (product?.includeExtra) {
            mainProduct?.product_id !== 5
                ? setModalOpened(true)
                : includeExtra({ value: !product?.includeExtra, product_id: product_id });
        } else {
            includeExtra({ value: !product?.includeExtra, product_id: product_id });
        }
    };

    return (
        <>
            <div className={'section__row'}>
                <div className={'section__cell section__cell--name'}>
                    <div>
                        <summary className={'title-3'}>
                            {product?.product_name}
                            <CirclePlus
                                onClick={handleDescriptionVisible}
                                className={'icon size-20 ml-10 cursor-pointer'} />
                        </summary>
                        <div className={cn({ hidden: !descriptionVisible })}>
                            <span className="accordion__summary"></span>
                            <ul className={'list'}>
                                {product?.product_description_items?.map((item, i) => (
                                    <li key={'product-description' + i}>{item}</li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
                <div className={'section__cell section__cell--billing tablet-pb-7'}>
                    <span className={'text-3 bold hide-desktop'}>Billing period</span>
                    <span className={'text-3'}>
                        {product?.period?.name}&nbsp;
                        {!!product?.period?.discount &&
                            getFormattedAmount(
                                product?.period?.discount,
                                '(<value:auto> OFF)',
                                {
                                    unit: product?.period?.unit?.toUpperCase(),
                                    currency: cart?.currency?.sign
                                }
                            )
                        }
                    </span>
                </div>
                <div className={'section__cell section__cell--sites tablet-pt-7 tablet-pb-7'}>
                    <span className={'text-3 bold hide-desktop'}>Units</span>
                    <span className={'text-3'}>{billingUnits || '-'}</span>
                </div>
                <div className={'section__cell section__cell--per-site tablet-pt-7 tablet-pb-7'}>
                    <span className={'text-3 bold hide-desktop'}>Cost per unit</span>
                    <span className={'text-3'}>{costPerSite}</span>
                </div>
                <div className={'section__cell section__cell--sum tablet-pt-7'}>
                    <span className={'text-3 bold hide-desktop'}>Sum 2222</span>
                    <span className={'text-3'}>{product?.tariff ? tariffCost : '-'}</span>
                </div>
            </div>
            {product?.extra_package_name && (
                <>
                    <div className={'section__row section__row--extra'}>
                        <div className={'section__cell section__cell--name'}>
                            <div className={'flex'}>
                                <div className="checkbox">

                                        <input
                                            type="checkbox"
                                            id={`extra-${product_id}`}
                                            className="checkbox__input"
                                            /* Extra flag is switching "globally" (for all products) */
                                            checked={mainProduct?.includeExtra || false}
                                            onChange={handleIncludeExtra}
                                            disabled={mainProduct?.product_id !== product?.product_id && !product?.isIncluded}
                                        />

                                    <label
                                        htmlFor={`extra-${product_id}`}
                                        className={'checkbox__label'}
                                    >
                                        <p className={'text-3 extra-package'}>
                                            <span className={'extra-package--name'}>
                                                {product?.extra_package_name}
                                            </span>
                                            { product_id !== mainProduct?.product_id && ( <span className={'extra-package--note'}>{getExtraPackageNote(mainProduct)}</span> ) }
                                        </p>
                                    </label>
                                </div>
                                <div>
                                <CirclePlus
                                        onClick={handleExtraVisible}
                                        className={'icon size-20 ml-10 cursor-pointer'}
                                    />
                                </div>
                            </div>

                            <div className={cn({ hidden: !extraVisible })}>
                                <div className="accordion__summary"></div>
                                <ul className={'list'}>
                                    {product?.extra_package_description_items?.map((item, i) => (
                                        <li key={'extra-package-description' + i}>{item}</li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                        <div className={'section__cell section__cell--billing tablet-pb-7'}>
                            <span className={'text-3 bold hide-desktop'}>Billing period</span>
                            <span className={'text-3'}>
                                {product?.period?.name}&nbsp;
                                {!!product?.period?.discount &&
                                    getFormattedAmount(
                                        product?.period?.discount,
                                        '(<value:auto> OFF)',
                                        {
                                            unit: product?.period?.unit?.toUpperCase(),
                                            currency: cart?.currency?.sign,

                                        }
                                    )
                                }
                            </span>
                        </div>
                        <div
                            className={'section__cell section__cell--sites tablet-pt-7 tablet-pb-7'}
                        >
                            <span className={'text-3 bold hide-desktop'}>Sites</span>
                            <span className={'text-3'}>-</span>
                        </div>
                        <div
                            className={
                                'section__cell section__cell--per-site tablet-pt-7 tablet-pb-7'
                            }
                        >
                            <span className={'text-3 bold hide-desktop'}>Cost per site</span>
                            <span className={'text-3'}>-</span>
                        </div>
                        <div className={'section__cell section__cell--sum tablet-pt-7'}>

                            {mainProduct?.includeExtra &&
                                <>
                                    <span className={'text-3 bold hide-desktop'}>Sum</span>
                                    <span className={'text-3'}>{sum}</span>
                                </>
                            }

                        </div>
                    </div>
                    {mainProduct?.includeExtra && (
                        <ReactModal
                            isOpen={modalOpened}
                            contentLabel="onRequestClose Example"
                            onRequestClose={() => setModalOpened(false)}
                            shouldCloseOnOverlayClick={false}
                            portalClassName={'modal__container'}
                            overlayClassName={'modal__overlay'}
                            className={'modal__content'}
                            bodyOpenClassName={'body--modal-opened'}
                            htmlOpenClassName={'html--modal-opened'}
                            ariaHideApp={false}
                            closeTimeoutMS={500}
                        >
                            <ExtraPackageDetails
                                setModalOpened={setModalOpened}
                                setExtraChecked={includeExtra}
                                product_id={product_id}
                                list={product?.extra_package_description_items}
                            />
                        </ReactModal>
                    )}
                </>
            )}
        </>
    );
}

const mapStateToProps = (state) => ({
    mainProductId: productCurrentProductIdSelector(state),
    mainProduct: cartMainProduct(state),
    cart: cartCartSelector(state),
    currency: cartCurrencySelector(state),
});

export default connect(mapStateToProps, null)(TableBody);
